import { ConsultationType } from 'src/pages/types';
import { rootReducer } from '..';
import { consultationTimeToFormatSeconds } from '../../pages/SchedulePage/utils';

type RootState = ReturnType<typeof rootReducer>;

export const consultationsSelector = (state: RootState): ConsultationType[] | null => state.consultations;

export const consultationsSortedByTimeSelector = (state: RootState): ConsultationType[] | [] => {
  if (!state.consultations) return [];

  const sortedArr = [...state.consultations];
  return sortedArr.sort(
    (a, b) =>
      consultationTimeToFormatSeconds(b.consultation_time) - consultationTimeToFormatSeconds(a.consultation_time)
  );
};

export const consultationsByVideoSelector = (videochatUrl: string) => {
  return (state: RootState): ConsultationType => {
    return state.consultations?.find((elem) => elem.videochat_url === videochatUrl)!;
  };
};

export const consultationsByIDSelector = (id: string) => {
  return (state: RootState): ConsultationType | undefined => {
    return state.consultations?.find((elem) => elem.id === id)!;
  };
};

export const consultationsBySpecialistIDSelector = (specialistID: string) => {
  return (state: RootState): ConsultationType[] | undefined => {
    return state.consultations?.filter((elem) => elem.psychologist_id === specialistID)!;
  };
};

export const selectConsultationsBySpecialistAndClient = (specialistID: string, clientId: string) => {
  return (state: RootState): ConsultationType[] | undefined => {
    return state.consultations?.filter((elem) => elem.psychologist_id === specialistID && elem.user_id === clientId)!;
  };
};

export const selectConsultationCountBySpecialist = (state: RootState) => {
  return state.consultations?.reduce((counts: { [key: string]: number }, consultation) => {
    const { psychologist_id } = consultation;
    if (!counts[psychologist_id]) {
      counts[psychologist_id] = 0;
    }
    counts[psychologist_id] += 1;
    return counts;
  }, {});
};
